import {
  FiUser,
  FiKey,
  FiBriefcase,
  FiShield,
  FiSliders,
  FiHash,
  FiPercent,
  FiBell,
  FiServer,
  FiMonitor,
  FiGlobe,
  FiMail,
  FiFileText,
} from "react-icons/fi";
import { isFreelance } from "../../../utils/constants/accountType";

const SETTINGS_GROUPS = [
  {
    title: "Organization",
    description: "Who you are and who can do what.",
    accent: "brand",
    items: [
      { label: "Account", to: "/settings/account", icon: FiUser, description: "Company profile, preferences and account ownership." },
      // { label: "License", to: "/settings/license", icon: FiKey, description: "Your plan, seats and renewal details." },
      // { label: "Legal Entities", to: "/settings/legal-entities", icon: FiBriefcase, description: "Companies you invoice and contract under." },
      { label: "Roles", to: "/settings/roles", icon: FiShield, description: "Manager roles and what each one can access.", enterpriseOnly: true },
    ],
  },
  {
    title: "Configuration",
    description: "Values and rules used across projects and finances.",
    accent: "teal",
    items: [
      { label: "System Values", to: "/system-values", icon: FiSliders, description: "Services, language pairs, units and currencies." },
      { label: "Custom Codes", to: "/settings/object-codes", icon: FiHash, description: "Numbering formats for projects, invoices and more." },
      {
        label: "Taxes", icon: FiPercent, description: "Tax rates and the defaults applied to clients and vendors.",
        children: [
          { label: "Taxes", to: "/settings/taxes", end: true },
          { label: "Default Tax for Client", to: "/settings/taxes/client-default" },
          { label: "Default Tax for Vendor", to: "/settings/taxes/vendor-default", enterpriseOnly: true },
        ],
      },
      { label: "Reminders", to: "/settings/reminders", icon: FiBell, description: "Automatic reminders for deadlines and due payments." },
    ],
  },
  {
    title: "Email & Portals",
    description: "How the system sends mail and what clients and vendors see.",
    accent: "purple",
    items: [
      { label: "SMTP Server", to: "/settings/smtp-server", icon: FiServer, description: "Outgoing mail server used for system emails." },
      { label: "Client Portal", to: "/settings/client-portal", icon: FiMonitor, description: "What clients can see and do in their portal." },
      { label: "Vendor Portal", to: "/settings/vendor-portal", icon: FiGlobe, description: "What vendors can see and do in their portal.", enterpriseOnly: true },
    ],
  },
  {
    title: "Templates",
    description: "Content of the emails and documents the system generates.",
    accent: "amber",
    items: [
      {
        label: "Email Templates", icon: FiMail, description: "Emails sent with quotes and invoices.",
        children: [
          { label: "Quote", to: "/settings/email-templates/quote" },
          { label: "Multi-Quote", to: "/settings/email-templates/multi-quote" },
          { label: "Client Invoice", to: "/settings/email-templates/client-invoice" },
        ],
      },
      {
        label: "PDF Templates", icon: FiFileText, description: "Layout of generated PDF documents.",
        children: [
          { label: "PDF Images", to: "/settings/pdf-templates/images" },
          { label: "Client Invoice", to: "/settings/pdf-templates/client-invoice" },
          { label: "Vendor Invoice", to: "/settings/pdf-templates/vendor-invoice", enterpriseOnly: true },
          { label: "Quote", to: "/settings/pdf-templates/quote" },
          { label: "Job PO", to: "/settings/pdf-templates/job-po", enterpriseOnly: true },
        ],
      },
    ],
  },
];

export const getSettingsGroups = (user) => {
  const freelance = isFreelance(user);
  const visible = (entry) => !(freelance && entry.enterpriseOnly);
  return SETTINGS_GROUPS.map((group) => ({
    ...group,
    items: group.items
      .filter(visible)
      .map((item) =>
        item.children ? { ...item, children: item.children.filter(visible) } : item
      ),
  }));
};

export const getSettingsSidebarItems = (user) =>
  getSettingsGroups(user).flatMap((group) =>
    group.items.map((item) =>
      item.children
        ? { label: item.label, subcategories: item.children }
        : { label: item.label, to: item.to }
    )
  );